// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__3a6Q7","slider_wrap":"Slider_slider_wrap__KTwKy","slider_item":"Slider_slider_item__LCCfB","slider_item_bg":"Slider_slider_item_bg__4c+lg"};